// extracted by mini-css-extract-plugin
export var columnList = "_f1-0";